// Core
import { useState } from 'react';
// Components
import { Button } from 'components/lib';
// I18n
import { t } from 'i18n';
// Styles
import styles from './reloadScreen.module.scss';

const ReloadScreen = () => {
  const [isReloading, setIsReloading] = useState(false);

  const handleReload = () => {
    setIsReloading(true);
    window.location.reload();
  };

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{t('errorBoundary.title')}</h1>

      <Button
        size="large"
        disabled={isReloading}
        onClick={handleReload}
        className={styles.reload}
      >
        {t('errorBoundary.goBack')}
      </Button>
    </div>
  );
};

export default ReloadScreen;
